import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

export const mapFieldReportTypeAttributeFilter = (item, index) => {
  return {
    ...item,
    index,
    key: uuidv4(),
    isEnabled: item?.is_active,
    status: getStatusByValue(item?.is_active),
  }
}

export const getReportTypeAttributeFilterListApi = ({ data_type_id }) => {
  const params = removeEmpty({
    data_type_id,
  })

  const config = {
    method: 'get',
    url: '/api/v1/filters/report_type_attribute',
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldReportTypeAttributeFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
